import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const PrivacyPage = () => {
  return (
    <main className="main">
      <div className="container">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          style={{
            maxWidth: '800px',
            margin: '0 auto',
            padding: '2rem 0'
          }}
        >
          {/* Back Navigation */}
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ delay: 0.2, duration: 0.6 }}
            style={{ marginBottom: '2rem' }}
          >
            <Link 
              to="/" 
              style={{
                color: '#64ffda',
                textDecoration: 'none',
                fontSize: '1rem',
                fontWeight: '600',
                display: 'inline-flex',
                alignItems: 'center',
                gap: '0.5rem',
                transition: 'all 0.3s ease'
              }}
            >
              ← Back to Home
            </Link>
          </motion.div>

          {/* Page Header */}
          <motion.div
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3, duration: 0.8 }}
            style={{
              textAlign: 'center',
              marginBottom: '3rem'
            }}
          >
            <h1 style={{
              fontSize: '3rem',
              fontWeight: '800',
              background: 'linear-gradient(135deg, #64ffda 0%, #00ff88 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              marginBottom: '1rem'
            }}>
              Privacy Policy
            </h1>
            <p style={{
              fontSize: '1.2rem',
              color: '#b0b0b0',
              maxWidth: '600px',
              margin: '0 auto'
            }}>
              How we collect, use, and protect your personal information
            </p>
          </motion.div>

          {/* Content */}
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.5, duration: 0.8 }}
            style={{
              background: 'rgba(255, 255, 255, 0.05)',
              borderRadius: '20px',
              padding: '3rem',
              border: '1px solid rgba(255, 255, 255, 0.1)',
              backdropFilter: 'blur(10px)'
            }}
          >
            <div style={{
              color: '#e0e0e0',
              lineHeight: '1.6',
              fontSize: '1rem'
            }}>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '0'
              }}>
                1. Information We Collect
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                We collect information you provide directly to us, such as when you contact us through our website, subscribe to our newsletter, or interact with our content. This may include:
              </p>
              <ul style={{ 
                marginBottom: '2rem',
                paddingLeft: '1.5rem',
                color: '#b0b0b0'
              }}>
                <li style={{ marginBottom: '0.5rem' }}>Name and email address</li>
                <li style={{ marginBottom: '0.5rem' }}>Messages and communications you send to us</li>
                <li style={{ marginBottom: '0.5rem' }}>Any other information you choose to provide</li>
              </ul>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                2. How We Use Your Information
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                We use the information we collect to:
              </p>
              <ul style={{ 
                marginBottom: '2rem',
                paddingLeft: '1.5rem',
                color: '#b0b0b0'
              }}>
                <li style={{ marginBottom: '0.5rem' }}>Respond to your inquiries and provide customer support</li>
                <li style={{ marginBottom: '0.5rem' }}>Send you updates about our tools and content (if you've subscribed)</li>
                <li style={{ marginBottom: '0.5rem' }}>Improve our website and services</li>
                <li style={{ marginBottom: '0.5rem' }}>Comply with legal obligations</li>
              </ul>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                3. Information Sharing
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                We do not sell, trade, or otherwise transfer your personal information to third parties without your consent, except as described in this policy. We may share your information with trusted service providers who assist us in operating our website and conducting our business, provided they agree to keep this information confidential.
              </p>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                4. Data Security
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                We implement appropriate security measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure.
              </p>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                5. Cookies and Tracking
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                Our website may use cookies and similar tracking technologies to enhance your browsing experience. You can choose to disable cookies through your browser settings, though this may affect the functionality of our website.
              </p>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                6. Third-Party Links
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                Our website contains links to third-party websites. We are not responsible for the privacy practices of these external sites and encourage you to review their privacy policies.
              </p>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                7. Your Rights
              </h2>
              <p style={{ marginBottom: '1rem' }}>
                You have the right to:
              </p>
              <ul style={{ 
                marginBottom: '2rem',
                paddingLeft: '1.5rem',
                color: '#b0b0b0'
              }}>
                <li style={{ marginBottom: '0.5rem' }}>Access the personal information we hold about you</li>
                <li style={{ marginBottom: '0.5rem' }}>Request correction of inaccurate information</li>
                <li style={{ marginBottom: '0.5rem' }}>Request deletion of your personal information</li>
                <li style={{ marginBottom: '0.5rem' }}>Opt out of marketing communications</li>
              </ul>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                8. Changes to This Policy
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                We may update this privacy policy from time to time. We will notify you of any changes by posting the new policy on this page and updating the "Last updated" date.
              </p>
              
              <h2 style={{
                color: '#64ffda',
                fontSize: '1.6rem',
                fontWeight: '700',
                marginBottom: '1rem',
                marginTop: '2rem'
              }}>
                9. Contact Us
              </h2>
              <p style={{ marginBottom: '2rem' }}>
                If you have any questions about this privacy policy or our data practices, please contact us at{' '}
                <a 
                  href="mailto:contact@extraterrestrialtools.com"
                  style={{
                    color: '#64ffda',
                    textDecoration: 'none',
                    fontWeight: '600'
                  }}
                >
                  contact@extraterrestrialtools.com
                </a>
              </p>
              
              <hr style={{
                border: 'none',
                height: '1px',
                background: 'linear-gradient(90deg, transparent, rgba(100, 255, 218, 0.3), transparent)',
                margin: '2rem 0'
              }} />
              
              <p style={{
                textAlign: 'center',
                color: '#64ffda',
                fontWeight: '600',
                fontSize: '0.9rem'
              }}>
                Copyright © Extraterrestrial Tools
              </p>
            </div>
          </motion.div>
        </motion.div>
      </div>
    </main>
  );
};

export default PrivacyPage;